module.exports = __webpack_public_path__ + "static/up-arrow.png";